var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleBlue5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#166bcd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.262 13.816q1.373 0 2.44.523a3.96 3.96 0 0 1 1.692 1.538q.615 1.015.615 2.502 0 1.62-.677 2.8-.666 1.168-2 1.794-1.322.625-3.301.625-1.18 0-2.225-.205-1.035-.195-1.815-.605V20.05q.78.41 1.866.698a8.5 8.5 0 0 0 2.061.276q.944 0 1.59-.246.645-.255.974-.779.338-.533.338-1.354 0-1.096-.738-1.681-.739-.585-2.266-.585-.585 0-1.22.113-.626.112-1.046.226l-1.262-.677.564-7.64h8.132v2.687H14.63l-.277 2.943q.35-.072.759-.143.41-.072 1.149-.072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleBlue5);
export default __webpack_public_path__ + "static/media/icon-circle-blue-5.30800d0d9f6c488a9ac0abff5b3fe8e3.svg";
export { ForwardRef as ReactComponent };